import { useState, useEffect, useRef } from 'react';
import { reverseGeocodePoint } from '../services/nominatimClient';

export default function useNominatim(lat, lng) {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const timerRef = useRef(null);
  const lastRequestRef = useRef(0);

  useEffect(() => {
    if (lat == null || lng == null) {
      setResult(null);
      setError(null);
      return;
    }

    if (timerRef.current) clearTimeout(timerRef.current);

    timerRef.current = setTimeout(async () => {
      const now = Date.now();
      const elapsed = now - lastRequestRef.current;
      if (elapsed < 1100) {
        await new Promise(r => setTimeout(r, 1100 - elapsed));
      }

      setLoading(true);
      setError(null);

      try {
        const geo = await reverseGeocodePoint(lat, lng);
        lastRequestRef.current = Date.now();
        if (geo) {
          setResult({
            direccion: geo.direccion,
            barrio: geo.barrio,
            localidad: geo.localidad,
            displayName: geo.direccion,
          });
        } else {
          setResult(null);
        }
      } catch (e) {
        setError(e.message);
        setResult(null);
      } finally {
        setLoading(false);
      }
    }, 400);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [lat, lng]);

  return { result, loading, error };
}
